import React from "react";
import Footer from "../footer/Footer";
import VTVenueTipHistory from "../page/VTVenueTipHistory";
import Header from "../header/Header";

export default function LandingVenueTipHistory({page}) {
    return (
        <>
            <Header headerType="AdminPayoutOnly"/>
            <VTVenueTipHistory/>
            <Footer/>
        </>
    );
}